export type CrmDiscountMode =
  | 'first_only'
  | 'every_payment'
  | 'renewal_only'
  | null
  | undefined

export interface PaymentDiscountAmounts {
  promoDiscountAmount?: number | null
  referralPromoDiscountAmount?: number | null
  referralBalanceAmount?: number | null
  crmDiscountAmount?: number | null
  crmDiscountMode?: CrmDiscountMode
  crmAppliedDiscountAmount?: number | null
  discountAmount?: number | null
}

const normalizePositiveDiscountAmount = (value?: number | null) => {
  const amount = Number(value ?? 0)

  return Number.isFinite(amount) && amount > 0 ? amount : 0
}

/** Итого в колонку «Скидка»: всегда discountAmount (включая 0). */
export const getPaymentDiscountColumnValue = (
  payment: PaymentDiscountAmounts,
) => {
  const raw = Number(payment.discountAmount)
  if (Number.isFinite(raw)) return String(Math.max(0, raw))
  return '0'
}

/**
 * Разбивка для tooltip:
 * promo + referral promo + referral balance + CRM applied.
 * Нулевые не показываем.
 */
export const getPaymentDiscountBreakdownLines = ({
  promoDiscountAmount,
  referralPromoDiscountAmount,
  referralBalanceAmount,
  crmAppliedDiscountAmount,
}: PaymentDiscountAmounts): string[] => {
  const lines: string[] = []

  const promoAmount = normalizePositiveDiscountAmount(promoDiscountAmount)
  const referralPromoAmount = normalizePositiveDiscountAmount(
    referralPromoDiscountAmount,
  )
  const referralBalance = normalizePositiveDiscountAmount(referralBalanceAmount)
  const crmApplied = normalizePositiveDiscountAmount(crmAppliedDiscountAmount)

  if (promoAmount) {
    lines.push(`Скидка по промокоду: ${promoAmount} ₽`)
  }
  if (referralPromoAmount) {
    lines.push(`Реферальная скидка: ${referralPromoAmount} ₽`)
  }
  if (referralBalance) {
    lines.push(`Списанный реферальный баланс: ${referralBalance} ₽`)
  }
  if (crmApplied) {
    lines.push(`Скидка CRM-ссылки: ${crmApplied} ₽`)
  }

  return lines
}

/**
 * @deprecated Используйте getPaymentDiscountColumnValue + getPaymentDiscountBreakdownLines.
 * Оставлено для финансовых отчётов без CRM-полей.
 */
export const formatPaymentDiscount = ({
  promoDiscountAmount,
  referralPromoDiscountAmount,
  referralBalanceAmount,
  discountAmount,
}: PaymentDiscountAmounts) => {
  const parts: string[] = []
  const promoAmount = normalizePositiveDiscountAmount(promoDiscountAmount)
  const referralPromoAmount = normalizePositiveDiscountAmount(
    referralPromoDiscountAmount,
  )
  const referralBalance = normalizePositiveDiscountAmount(referralBalanceAmount)

  if (promoAmount) parts.push(String(promoAmount))
  if (referralPromoAmount) {
    parts.push(`${referralPromoAmount} рублей (Реф.Промокод)`)
  }
  if (referralBalance) {
    parts.push(`${referralBalance} рублей (Реф.Баланс)`)
  }

  return parts.length
    ? parts.join('\n')
    : getPaymentDiscountColumnValue({ discountAmount })
}
